import React from 'react';
import { View, Pressable } from 'react-native';
import DataTable from '@preflighttech/preflight-tables';
import styled from 'styled-components/native';

import minimalTable from 'app/src/elements/minimalTable';
import useToggle from 'app/src/hooks/useToggle';
import { Text } from 'app/src/styles';
import { Link } from 'app/src/utils/routing';
import { currency } from 'app/src/utils/stringHelpers';
import { dateShort } from 'app/src/utils/timeFormatter';

const TxnDetails = styled(View)`
  flex-direction: row;
  gap: 10px;
  margin-top: 6px;
`;

const DetailText = styled(Text)`
  min-width: 100px;
`;

const saleAssetBaseColumns = [
  {
    key: 'lotNumber',
    label: 'Lot #',
    value: ({ entry }) => entry.saleAsset.lotNumber,
  },
  {
    key: 'paddleNumber',
    label: 'Paddle #',
    value: ({ entry }) => entry.saleAsset.paddleNumber,
  },
  {
    key: 'stockNumber',
    label: 'Stock #',
    value: ({ entry }) => entry.saleAsset.asset.stockNumber,
  },
  {
    key: 'soldOrIfPrice',
    label: 'Sale Price',
    cellStyle: { textAlign: 'right' },
    value: ({ entry }) => entry.saleAsset.soldOrIfPrice,
    content: ({ value }) => currency(value),
  },
  {
    key: 'debitLessCredit',
    label: 'Payment Amount',
    cellStyle: { textAlign: 'right' },
    content: ({ value }) => currency(value),
  },
];

const PaddleServicePayment = ({ txn, creditAmounts, setCreditAmounts }) => {
  const [showLines, toggleShowLines] = useToggle();

  const saleAssetLines = txn.txnLines.filter(txnLine => txnLine.saleAsset);

  const saleAssetColumns = [...saleAssetBaseColumns];

  if (creditAmounts && 'Paddle Service Credit' !== txn.type) {
    saleAssetColumns.push({
      key: 'add',
      label: 'Add to Credit?',
      sort: 'prevent',
      content: ({ entry }) => {
        const isChecked = !!(creditAmounts.find(
          txnLine => txnLine.id === entry.id
        ));

        return (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={() => {
              if (isChecked) {
                setCreditAmounts(
                  [...creditAmounts.filter(txnLine => txnLine.id !== entry.id)]
                );
              } else {
                setCreditAmounts([ ...creditAmounts, entry ]);
              }
            }}
          />
        );
      }
    });
  }

  return (
    <View>
      <TxnDetails>
        <DetailText style={{ fontWeight: 600, minWidth: 140 }}>
          {txn.name}
        </DetailText>
        <DetailText>{currency(txn.amount)}</DetailText>
        <DetailText>{dateShort(txn.bankDate)}</DetailText>
        <DetailText>
          {'Paddle Service Credit' === txn.type ? 'CREDIT ' : 'Inv #: '}
          {txn.reference}
        </DetailText>
        <Pressable onPress={toggleShowLines}>
          <DetailText>{showLines ? 'Hide' : 'Show'} Lots</DetailText>
        </Pressable>
        <Link to={`/accounting/transactions/${txn.id}`}>
          <DetailText>Edit Debits/Credits</DetailText>
        </Link>
      </TxnDetails>

      {showLines && (
        <View style={{ marginBottom: 24 }}>
          <DataTable.Simple
            data={saleAssetLines}
            columns={saleAssetColumns}
            component={minimalTable}
            pageLength="All"
          />
        </View>
      )}
    </View>
  );
};

export default PaddleServicePayment;
